<template>
    <v-expand-transition >
        <div v-if="hasSuggestion">
            <div class="suggestion-container">
                <div class="d-flex">
                    <v-icon class="mr-2" color="warning">info</v-icon>
                    <div class="mt-auto mb-auto">
                        <b style="font-size: 18px;">Différence détectée</b>
                    </div>
                </div>

                <div class="mt-3" v-if="fieldCode === 'PHONE'">
                    Un nouveau numéro de téléphone a été détecté sur {{ getLowerCaseSourceName(getSuggestionByTypeName().source.type) }} :
                    <b>{{ getSuggestionByTypeName().value }}</b>
                </div>
                <div class="mt-3" v-else>
                    Une nouvelle adresse e-mail a été détectée sur {{ getLowerCaseSourceName(getSuggestionByTypeName().source.type) }} :
                    <b>{{ getSuggestionByTypeName().value }}</b>
                </div>

                <div class="d-flex justify-content-center flex-wrap mt-4 mb-2">
                    <v-btn class="text-none mr-5"
                           color="warning"
                           v-if="fieldCode === 'PHONE'"
                           large
                           style="border-radius: 25px; border-width: 2px; font-weight: bold"
                           outlined
                           @click="addSuggestion">
                        Ajouter ce téléphone
                    </v-btn>
                    <v-btn class="text-none mr-5"
                           color="warning"
                           v-else
                           large
                           style="border-radius: 25px; border-width: 2px; font-weight: bold"
                           outlined
                           @click="addSuggestion">
                        Ajouter cet e-mail
                    </v-btn>

                    <v-btn class="text-none ml-5"
                           text
                           color="#ffa533"
                           style="font-size: 16px"
                           @click="removeSuggestion">
                        Ignorer
                    </v-btn>
                </div>
            </div>
        </div>
    </v-expand-transition>
</template>

<script>
import {mapState, mapMutations, mapGetters} from "vuex"
export default {
    name: "CommunicationSuggestion",
    props: ['field'],
    computed: {
        ...mapState('web_form', ['provider', 'suggestedCommunications']),
        ...mapGetters('web_form', ['getCodeFromField']),
        fieldCode() {
            return this.getCodeFromField(this.field)
        },
        hasSuggestion() {
            return this.suggestedCommunications.find(suggestion => suggestion.type.name === this.fieldCode) !== undefined
        }
    },
    methods: {
        ...mapMutations('web_form', ['pushSuggestedCommunications']),
        getSuggestionByTypeName() {
            let exist = this.suggestedCommunications.find(com => com.type.name === this.fieldCode)

            return exist !== undefined ? exist : null
        },
        getLowerCaseSourceName(name) {
            return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
        },
        addSuggestion() {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if(suggestion.type.name === this.fieldCode) {
                    let communications = this.provider.communications.filter(com => com.type.name === suggestion.type.name)

                    if(communications !== undefined && (communications[0].value === null || communications[0].value === '')) {
                        this.provider.communications.forEach(com => {
                            if(com.type.name === suggestion.type.name) {
                                com.value = suggestion.value
                            }
                        })
                    } else {
                        let com = {
                            value: suggestion.value,
                            type: suggestion.type
                        }

                        this.provider.communications.push(com)
                    }

                    this.suggestedCommunications.splice(index, 1)
                }
            })
        },
        removeSuggestion() {
            this.suggestedCommunications.forEach((suggestion, index) => {
                if(suggestion.type.name === this.fieldCode) {
                    this.suggestedCommunications.splice(index, 1)
                }
            })
        },
    }
}
</script>

